export enum CountryCode {
  US = 'US',
  MX = 'MX',
  CAN = 'CAN'
}
export interface Country {
  key: CountryCode;
  name: string;
}

export const MX_STATES = [
  'Ags.',
  'B.C.',
  'B.C.S',
  'Camp.',
  'Chis.',
  'Chih.',
  'Coah.',
  'Col.',
  'CDMX',
  'Dgo.',
  'Gto.',
  'Gro.',
  'Hgo.',
  'Jal.',
  'Mex.',
  'Mich.',
  'Mor.',
  'Nay.',
  'N.L.',
  'Oax.',
  'Pue.',
  'Qro.',
  'Q.R.',
  'S.L.P.',
  'Sin.',
  'Son.',
  'Tab.',
  'Tamps.',
  'Tlax.',
  'Ver.',
  'Yuc.',
  'Zac.'
];

export const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'AS',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'CM',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'TT',
  'UT',
  'VT',
  'VA',
  'VI',
  'WA',
  'WV',
  'WI',
  'WY'
];

export const CAN_STATES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NT',
  'NS',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT'
];

export const supportedCountries: Country[] = [
  {
    key: CountryCode.US,
    name: 'United States'
  },
  {
    key: CountryCode.MX,
    name: 'Mexico'
  },
  {
    key: CountryCode.CAN,
    name: 'Canada'
  }
];

export const timezonesSupported = [
  {
    key: 'PST',
    name: 'Pacific Time'
  },
  {
    key: 'EST',
    name: 'Eastern Time'
  },
  {
    key: 'CST',
    name: 'Central Time'
  },

  {
    key: 'MST',
    name: 'Mountain Time'
  },
  {
    key: 'AKST',
    name: 'Alaska Time'
  }
];
